import { useAppSelector } from 'store/useAppSelector';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { useInitPersonalAccount } from 'modules/personalAccount/hooks/useInitPersonalAccount';
import { useTeamAccountJWTQuery } from 'modules/teamAccount/actions/hooks/useTeamAccountJWTQuery';

import {
  selectSelectedAccountJWT,
  selectSelectedAccountJWTLoading,
} from '../store/selectors';
import { useAccount } from './useAccount';

export interface IUseAccountJWTProps {
  skipFetching?: boolean;
}

export const useAccountJWT = ({ skipFetching }: IUseAccountJWTProps = {}) => {
  const { authAddress } = useAuth();
  const { group, isTeamAccount } = useAccount();

  useInitPersonalAccount({ skipFetching: skipFetching || isTeamAccount });

  useTeamAccountJWTQuery({
    group: group!,
    skipFetching: skipFetching || !isTeamAccount,
  });

  const accountJWT = useAppSelector(state =>
    selectSelectedAccountJWT(state, { authAddress, group }),
  );

  const loading = useAppSelector(state =>
    selectSelectedAccountJWTLoading(state, { authAddress, group }),
  );

  return { accountJWT, loading };
};
